module.exports = __webpack_public_path__ + "img/fuwu_gaoxiao.670fc91e.png";